import baseURL from "../common/axios";
class Commonservices {
  insert(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("OtherTermsMAS/Create", objinsert);
  }
  getdata() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("OtherTermsMAS/List");
  }
  Edit(EditId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get(
      "OtherTermsMAS/Get?id=" + EditId + ""
    );
  }
  Delete(DelID) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete(
      "OtherTermsMAS/Delete?id=" + DelID
    );
  }
  Active(Id, Status) {
    return baseURL.httpMSInventoryUrl.put(
      "OtherTermsMAS/Active?id=" + Id + "&Status=" + Status + ""
    );
  }
  Update(objupdate) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("OtherTermsMAS/Update", objupdate);
  }
}
export default new Commonservices();
